"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCoolOffPeriodLimits = void 0;
var react_1 = require("react");
// import { CoolingOffLimitDurationEnum } from '@l2p/profile-api'
var next_intl_1 = require("next-intl");
var useCoolOffPeriodLimits = function () {
    var t = (0, next_intl_1.useTranslations)('lossPeriods');
    return (0, react_1.useMemo)(function () {
        return [];
        // return Object.values(CoolingOffLimitDurationEnum).map(value => ({
        //   label: t(`${value}`),
        //   value,
        // }))
    }, []);
};
exports.useCoolOffPeriodLimits = useCoolOffPeriodLimits;
